import { render, staticRenderFns } from "./VisitDetail.vue?vue&type=template&id=28c12dfb&scoped=true"
import script from "./VisitDetail.vue?vue&type=script&lang=js"
export * from "./VisitDetail.vue?vue&type=script&lang=js"
import style0 from "./VisitDetail.vue?vue&type=style&index=0&id=28c12dfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c12dfb",
  null
  
)

export default component.exports